<template>
  <ul>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[shared_eq]': true })">
        {{ $t('root.filters.shared_yes') }}
      </router-link>
    </li>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[shared_eq]': false })">
        {{ $t('root.filters.shared_not') }}
      </router-link>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
  }
</script>
